<div class="analytics-card">
  <div class="card-body">
    <h5 class="card-title mb-3">Top Attacked Users</h5>

    <div class="table-responsive">
      <table class="table table-striped user-grid">
        <thead>
          <tr>
            <th scope="col">User Name</th>
            <th scope="col">User Title</th>
            <th scope="col">Department</th>
            <th scope="col">Attack Count</th>
          </tr>
        </thead>
        <tbody>
          @for (user of topAttackedUsers()?.topAttackedUsers ?? []; track $index) {
            <tr>
              <td>{{ user.name }}</td>
              <td>{{ user.title }}</td>
              <td>{{ user.department }}</td>
              <td>
                <div class="attack-count">
                  <span class="count">{{ user.attackCount }}</span>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td
                colspan="4"
                class="text-muted text-center py-3"
              >
                No data
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
